import { OnInit, Directive } from '@angular/core';
import { ModelService } from "../../../../Services/model.service";
import { UserActionBaseComponent } from '../userAction-base.component';
import { LoginService } from 'app/Services/login.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';

@Directive()
export abstract class UserActionByListComponent extends UserActionBaseComponent{
  _inputList: string = "";

  constructor(public loginService: LoginService, public macroService: MacroService) {
    super(loginService, macroService);
  }

  protected formatList(value) {
    var tmp: string = value;
    tmp = tmp.split(";").join("\n");
    tmp = tmp.split("\r").join("\n");
    tmp = tmp.split(" ").join("\n");
    tmp = tmp.split(",").join("\n");
    while (tmp.includes("\n\n")) {
      tmp = tmp.replace("\n\n", "\n");
    }
    if (tmp.substr(0, 1) == "\n") {
      tmp = tmp.substr(1);
    }
    if (tmp.substr(-1, 1) == "\n") {
      tmp = tmp.substr(0, tmp.length - 1);
    }
    return tmp;
  }

  protected formatListIgnoreSpace(value) {
    var tmp: string = value;
    tmp = tmp.split(";").join("\n");
    tmp = tmp.split("\r").join("\n");
    tmp = tmp.split(",").join("\n");
    while (tmp.includes("\n\n")) {
      tmp = tmp.replace("\n\n", "\n");
    }
    if (tmp.substr(0, 1) == "\n") {
      tmp = tmp.substr(1);
    }
    if (tmp.substr(-1, 1) == "\n") {
      tmp = tmp.substr(0, tmp.length - 1);
    }
    return tmp;
  }


  onValueChangedFormatList(event) {
    if (event.event == null)
      return;

    this.inputList = this.formatList(event.value);
  }

  onValueChangedFormatListIgnoreSpace(event) {
    if (event.event == null)
      return;

    this.inputList = this.formatListIgnoreSpace(event.value);
  }

  get inputList(): string {
    return this._inputList;
  }

  set inputList(value: string) {
    this._inputList = value;
  }

}
